import type { Path, PathGpsCoordinates } from '@sodraberget/shared/src/interfaces';

type HierarchyPath = Pick<Path, 'id' | 'compositeChildPathIds'>;

export const getVisiblePaths = <T extends HierarchyPath>(
    paths: T[],
    coordinates: PathGpsCoordinates,
    ids?: string[],
    activePathId?: string,
): T[] => {
    const allowedIds = ids?.length ? new Set(ids.map(String)) : undefined;
    const availablePaths = paths.filter(path =>
        (!allowedIds || allowedIds.has(String(path.id))) && coordinates[path.id]?.length > 0,
    );
    const availableIds = new Set(availablePaths.map(path => String(path.id)));
    const hiddenIds = new Set<string>();
    const expandedChildIds = new Set<string>();

    availablePaths.forEach(path => {
        const childIds = (path.compositeChildPathIds ?? []).map(String)
            .filter(id => id !== String(path.id) && availableIds.has(id));
        if (!childIds.length) {
            return;
        }

        if (activePathId === String(path.id) || childIds.includes(activePathId ?? '')) {
            hiddenIds.add(String(path.id));
            childIds.forEach(id => expandedChildIds.add(id));
        } else {
            childIds.forEach(id => hiddenIds.add(id));
        }
    });

    return availablePaths.filter(path =>
        !hiddenIds.has(String(path.id)) || expandedChildIds.has(String(path.id)),
    );
};
